import { useEffect, useState } from 'react';

function useDelayedValue(value, delay = 300) {
  const [delayedValue, setDelayedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDelayedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return delayedValue;
}

export default useDelayedValue;
